'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Tab slider animation
 * @param props TabSliderProps
 */ const TabSlider = (props)=>{
    const { activeIndex , className , numberOfTabs , ...spanProps } = props;
    const getWidth = ()=>Number((100 / numberOfTabs).toFixed(3));
    const [left, setLeft] = React.useState('0%');
    const [width, setWidth] = React.useState(getWidth());
    React.useEffect(()=>{
        const w = getWidth();
        setWidth(w);
        setLeft(`${w * activeIndex}%`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeIndex,
        numberOfTabs
    ]);
    return /*#__PURE__*/ React__default.default.createElement("span", _extends({}, spanProps, {
        className: classnames__default.default({
            'bf-tabs__slider': true,
            [`${className}`]: !!className
        }),
        role: "presentation",
        style: {
            left,
            // if one tab, defaults to 100% via tab_slider.module.scss
            width: numberOfTabs > 1 ? `${width}%` : undefined
        }
    }));
};

exports.TabSlider = TabSlider;
//# sourceMappingURL=tab-slider.js.map
